import React from 'react'

const SvgComponent = props => (
  <svg viewBox="0 0 424 365" fill="none" {...props}>
    <path
      d="M101.804 155.477c19.848 11.578 20.124 30.049.275 41.627-19.848 11.578-52.102 11.578-71.951 0-20.124-11.303-20.124-30.049-.276-41.627 19.573-11.303 51.827-11.303 71.952 0z"
      fill="#00A355"
    />
    <path
      opacity={0.6}
      d="M95.586 174.201v-1.242-1.552-1.862-2.484-2.794-3.415-3.725c0-1.242 0-2.794-.31-4.036v-.621c0-.621 0-1.242-.31-1.862 0-.621-.31-1.242-.31-1.863s-.311-1.552-.622-2.173c-.31-.932-.62-1.863-.93-2.484v-.31c-.31-.932-.932-2.484-1.242-3.415-.931-1.863-1.552-3.415-2.172-4.036-.31-.31-.621-.931-.931-1.242-.31-.31-.621-.931-.621-1.241-.62-.932-1.241-1.863-2.172-2.794l-.31-.311c0-.31-.311-.31-.311-.621-.31-.31-.62-.621-.62-.931a34.666 34.666 0 0 0-2.794-3.105c-1.241-1.241-3.103-2.794-4.655-4.035l-.31-.311c-.931-.931-2.483-1.862-3.725-2.483-.31-.311-.93-.621-1.241-.932-.931-.62-1.862-1.241-3.414-1.862-.31 0-.62-.311-.93-.311-.311 0-.311-.31-.622-.31-.31 0-.62-.311-.62-.311s-.31 0-.31-.31c-1.242-.621-2.483-1.242-4.345-1.863-.931-.31-1.552-.621-2.483-.931h-.31c-.31 0-.31-.31-.621-.31-.31-.311-.931-.621-1.242-.932v-2.794l.31-.31.311-.311c.31-.31.62-.31.931-.621.31 0 .31-.31.62-.31.311 0 .311-.31.622-.31.31 0 .93-.311 1.551-.621h.31c2.483-.932 4.656-1.863 6.828-3.105h.31c.621-.31.932-.621 1.552-.931.31 0 .31-.311.621-.311.31-.31.62-.31.931-.62.31-.311.62-.311.931-.621.31-.311.62-.311.62-.621.311-.31.621-.31.932-.621l.31-.31h.31c1.552-1.242 3.104-2.484 4.656-3.415l.93-.932c.932-.931 1.863-1.552 2.483-2.173 0-.31.31-.31.31-.62 1.242-1.242 1.863-1.863 1.863-2.174 0-.31.31-.31.31-.62.31-.311.31-.622.62-.932.311-.31.622-.931.932-1.242.62-.931 1.241-1.552 1.862-2.794 0-.31.31-.62.31-.62l.931-1.863s0-.31.31-.31c.311-.622.621-1.243.932-2.174 0-.31.31-.62.31-.931v-.31c0-.311.31-.622.31-.932.31-.62.621-1.242.621-1.863.31-.62.31-1.241.62-1.862.621-1.863.932-4.036 1.242-5.588 0-.621.31-1.553.31-2.173 0-1.242.31-2.794.31-3.726V41.952c-.31-6.209-4.344-12.417-12.413-17.074-8.38-5.278-20.172-7.761-31.655-7.761S28.24 19.6 19.552 24.877c-8.07 4.658-12.104 10.866-12.414 17.075V61.51c0 1.242 0 2.484.31 3.726 0 .93 0 1.552.31 2.173.311 1.862.621 4.035 1.242 5.588 0 .931.31 1.552.62 2.173.311.62.311 1.242.621 1.862 0 .31.31.621.31.932v.31c0 .31.311.621.311.931.31.621.62 1.553.931 2.174 0 0 0 .31.31.31l.931 1.863c0 .31.31.31.31.62l1.863 2.795c.31.62.62.93.93 1.241.311.31.311.621.622.932 0 .31.31.31.31.62 0 0 .62.932 1.862 2.174 0 .31.31.31.31.62.621.621 1.552 1.553 2.483 2.174l.931.931c1.242 1.242 2.793 2.484 4.655 3.415h.31l.311.31c.31.31.62.31.931.621.31.311.62.311.62.621.311.311.622.311.932.621.31.31.62.31.93.621.311 0 .311.31.621.31.621.311.932.621 1.552.932h.31c2.173 1.241 4.345 2.173 6.828 3.104h.31c.621.311.932.311 1.552.621.31 0 .31.31.62.31.311 0 .311.311.622.311.31.31.62.31.93.621l.311.31.31.311v2.794c-.31.31-.62.621-1.241.931 0 0-.31.31-.62.31h-.311c-.931.311-1.552.621-2.483.932-1.552.621-3.103 1.242-4.345 1.862 0 0-.31 0-.31.311-.31 0-.62.31-.62.31-.311 0-.311.311-.621.311s-.621.31-.931.31c-1.242.621-2.483 1.242-3.414 1.863-.62.31-.931.621-1.242.931-1.241.932-2.793 1.863-3.724 2.484l-.31.31c-1.552 1.242-3.414 2.794-4.655 4.036-.62.621-1.552 1.552-2.793 3.104-.31.311-.621.621-.621.932 0 .31-.31.31-.31.621l-.31.31c-.621.931-1.242 1.863-2.173 2.794-.31.31-.62.931-.931 1.242-.31.621-.62.931-.931 1.242 0 0-.931 1.552-1.862 3.414-.621.932-.931 2.484-1.552 3.415v.311c-.31.931-.62 1.552-.931 2.483-.31.621-.31 1.242-.62 2.173 0 .621-.311 1.242-.311 1.863s-.31 1.242-.31 1.863v.621c-.31 1.241 0 2.794-.31 4.035v18.627-.31c-.311 6.829 4.344 13.659 13.654 18.937 8.69 4.656 19.863 7.14 30.725 7.14 11.172 0 22.344-2.484 30.724-7.14 9.31-5.278 13.655-12.108 13.655-18.937v.31c.31 0 .31-.621.31-1.242z"
      fill="#fff"
    />
    <path
      d="M10.552 63.062v1.863c0 .62 0 1.552.31 2.173.31 1.863.62 3.725 1.242 5.278.31.31.31.93.62 1.552.31.62.931 2.483.931 2.483l.62 1.242.932 1.863.31.31c0 .31.31.931.621 1.552l.62.932c.621.931.932 1.552 1.552 2.483.31.31.621.932.931 1.242l.931.931s.621.932 1.552 1.863l.31.31 2.173 2.174.62.62.311.31c1.241 1.243 2.793 2.174 4.345 3.416l.31.31 2.483 1.553 1.552.93c.31.311.93.622 1.551.932 1.862.931 4.035 1.863 6.207 2.794l2.793.931c.31 0 .621.311.931.311.621.31.931.621 1.552.931l.31.311.31.31c.311.311.311.621.621.621l.31.621v.31c.622 1.242 1.863 3.415 2.173 6.209 0-.31 0-5.277 2.793-7.14l.31-.31.621-.621.31-.311c.311-.31.932-.621 1.553-.931.31 0 .31 0 .62-.311l.62-.31 1.863-.621c2.483-.931 4.655-1.863 6.517-3.104.31-.31.931-.621 1.552-.621l1.552-.931.93-.621L72 95.659c1.552-.931 2.793-2.173 4.345-3.415.31-.31.62-.31.93-.62.932-.932 1.553-1.553 2.484-2.174l.31-.31c.931-.932 1.552-1.863 1.552-1.863l.93-1.242c.311-.31.621-.62.932-1.242.62-.931.93-1.552 1.551-2.483l.31-.621c.311-.621.622-.931.932-1.552l.31-.31.931-1.864.31-.31s.932-2.483 1.242-3.104c.31-.621.31-.932.62-1.863.311-1.552.932-3.415 1.242-5.278 0-.62.31-1.241.31-2.173v-1.862h-80.69v-.31z"
      fill="url(#timely-payment__paint0_linear)"
    />
    <path
      d="M91.552 66.477c0-.62 0-1.242.31-1.552v-1.863h-81.31v1.863c0 .62 0 1.552.31 2.173v.62c1.242 4.347 4.966 8.693 10.862 12.108C37.241 89.14 63 89.45 79.138 80.447c7.138-3.725 11.172-8.692 12.414-13.97z"
      fill="#FFE4CF"
    />
    <path
      d="M80.69 46.298c-15.518-9.313-41.276-9.623-57.414-.62-16.448 9.313-17.07 24.214-1.241 33.527 15.517 9.314 41.275 9.624 57.413.621 16.138-9.313 16.759-24.214 1.242-33.528z"
      fill="url(#timely-payment__paint1_linear)"
    />
    <path
      d="M51.207 144.709c-24.517 0-40.655 26.388-40.655 30.734 0 5.898 4.034 11.486 11.793 15.832 7.759 4.347 18 6.83 29.172 6.83 10.862 0 21.414-2.483 29.173-6.83 7.758-4.346 12.103-9.934 11.793-15.832-9.31-16.454-24.517-30.734-41.276-30.734z"
      fill="url(#timely-payment__paint2_linear)"
    />
    <path
      opacity={0.3}
      d="M14.276 145.64c-.31 0-.62 0-.931-.31-1.552-.621-2.173-2.173-1.552-3.725.31-.621.31-.932.62-1.242l1.863-3.726.93-1.241c.311-.621.311-.932.622-1.242.62-.931 1.241-1.863 1.862-2.484l1.241-1.552 2.793-2.794c1.242-1.242 2.793-2.483 4.345-4.036l.62-.62c1.242-.621 2.483-1.553 3.725-2.174.62-.31.93-.62 1.241-.931l1.242-.621c1.241-.931 3.103-.31 4.034.932.931 1.241.31 3.104-.931 4.035l-.931.621c-.31.311-.931.621-1.241.932-.931.62-2.173 1.241-2.794 1.862l-.62.621c-1.552 1.242-3.104 2.484-4.035 3.415-.31.31-1.241 1.242-2.172 2.483l-1.241 1.553c-1.242.31-1.863 1.241-2.483 1.862-.31.311-.31.621-.62.932l-.622 1.552c-.31.31-.93 1.552-1.551 3.104-.31.311-.31.621-.621.932-.62 1.241-1.552 1.862-2.793 1.862z"
      fill="#fff"
    />
    <path
      opacity={0.6}
      d="M28.241 96.28c-.62 0-1.24-.31-1.862-.621-.93-.62-1.551-1.242-2.482-1.863l-.931-.931-2.173-2.173-.31-.621c-.931-1.242-1.552-1.863-1.862-1.863L18 86.967c-.311-.31-.622-.932-.932-1.242-.62-.931-1.241-1.552-1.552-2.484l-.62-.62c-.31-.311-.621-.932-.931-1.553l-.31-.62-.932-1.863-1.552-3.726c-.31-.62-.31-1.241-.62-1.862-.31-1.242-.62-2.794-.931-4.347-.31-1.552.62-3.104 2.172-3.415 1.552-.31 3.104.621 3.414 2.174.31 1.241.62 2.794.931 3.725 0 .62.31.931.31 1.242l.931 2.173L18 75.79c0 .93.31 1.552.62 1.862l.311.621c.31.621.62.931.62 1.242l.622.931c.62.932.93 1.242 1.551 2.173.31.31.62.621.62.932l.932 1.241c0 .31.62.621 1.241 1.553l.31.31c.621.621 1.242 1.242 2.173 1.863l.931.931c.62.621 1.552 1.242 2.172 1.863 1.242.931 1.552 2.794.621 4.035-.62.621-1.552.932-2.483.932z"
      fill="#fff"
    />
    <path
      d="M102.414 29.845h-2.173c-2.172-4.346-6.207-8.692-12.103-12.107C68.586 5.63 36.31 5.32 15.828 16.806 9 20.532 4.655 24.878 2.172 29.845H0v9.313c.31 7.14 4.966 13.97 14.276 19.558 19.552 11.797 52.138 12.107 72.31.621 9.931-5.588 15.207-13.039 15.828-20.179v-9.313z"
      fill="#B57561"
    />
    <path
      d="M88.138 9.045C68.586-2.752 36.31-3.062 15.828 8.425-4.655 19.91-5.276 38.536 14.276 50.334c19.552 11.796 52.138 12.106 72.31.62 20.483-11.176 21.104-30.113 1.552-41.91z"
      fill="#D29370"
    />
    <path
      d="M255.785 322l76.919-34.227-67.276-42.037L255.785 322z"
      fill="#00A355"
    />
    <path
      d="M335 285.017l-22.731-149.081c-.46-2.527-2.756-5.743-5.281-7.351l-176.57-97.627c-2.526-1.378-4.133-.459-3.904 2.298l22.961 148.851c.459 2.527 2.755 5.743 5.281 7.121l176.341 97.856c2.525 1.608 4.362.459 3.903-2.067z"
      fill="url(#timely-payment__paint3_linear)"
    />
    <path
      d="M309.284 136.854c.918-3.216-.46-6.891-2.985-8.269L130.877 30.729c-2.526-1.378-5.281 0-5.97 3.216l-15.384 57.427 184.606 102.68 15.155-57.198z"
      fill="#fff"
    />
    <path
      d="M109.5 91L76.23 215.415c-.919 3.216.459 6.891 2.985 8.269l175.651 97.627c2.526 1.378 5.281 0 5.97-3.216l33.293-124.273L109.5 91z"
      fill="url(#timely-payment__paint4_linear)"
    />
    <path
      d="M172.431 111.403l-21.208 1.248-1.248 5.304 19.961 2.184-24.327 90.487 6.237 3.433 26.511-99.224-5.926-3.432zM230.754 145.101l-16.218-9.36c-9.98-5.929-20.273-3.12-24.015 11.545l-14.659 55.228c-4.367 16.225 2.807 26.834 12.475 32.45l16.219 9.361c10.604 5.928 19.337 4.368 23.703-11.857l14.659-55.228c2.807-11.857.624-24.65-12.164-32.139zm5.614 28.707l-14.659 55.228c-2.495 8.736-7.173 12.169-15.594 7.488l-16.218-9.36c-6.55-3.745-11.228-10.921-8.421-21.218l14.659-55.228c2.183-8.425 8.109-11.857 15.906-7.177l16.218 9.361c9.045 4.992 10.604 12.481 8.109 20.906z"
      fill="#00C366"
      stroke="#00C366"
      strokeWidth={5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M146.949 22.689c-2.984-1.608-5.969 0-6.888 3.675l-4.822 18.377c-.918 3.675.46 8.04 3.445 9.648 2.984 1.608 5.969 0 6.888-3.675l4.822-18.377c.918-3.676-.689-8.04-3.445-9.648zM171.288 36.242c-2.985-1.608-5.97 0-6.888 3.675l-4.822 18.377c-.918 3.675.459 8.04 3.444 9.648 2.985 1.608 5.97 0 6.889-3.676l4.821-18.376c.919-3.676-.689-8.04-3.444-9.648zM195.627 49.795c-2.985-1.608-5.97 0-6.889 3.675l-4.821 18.377c-.919 3.675.459 8.04 3.444 9.648 2.985 1.608 5.97 0 6.888-3.676l4.822-18.377c.918-3.675-.459-7.81-3.444-9.647zM219.965 63.577c-2.985-1.608-5.969 0-6.888 3.676l-4.822 18.376c-.918 3.676.46 8.04 3.444 9.648 2.985 1.608 5.97 0 6.889-3.675l4.822-18.377c1.148-3.675-.46-8.04-3.445-9.648zM244.534 77.13c-2.985-1.608-5.97 0-6.889 3.675l-4.821 18.377c-.919 3.675.459 8.04 3.444 9.648 2.985 1.608 5.97 0 6.888-3.675l4.822-18.377c.918-3.675-.689-8.04-3.444-9.648zM268.872 90.683c-2.985-1.608-5.97 0-6.888 3.675l-4.822 18.377c-.918 3.675.459 8.04 3.444 9.648 2.985 1.608 5.97 0 6.889-3.676l4.821-18.376c.919-3.676-.688-8.04-3.444-9.648zM293.211 104.236c-2.985-1.608-5.97 0-6.888 3.675l-4.822 18.377c-.919 3.675.459 8.04 3.444 9.648 2.985 1.608 5.97 0 6.888-3.676l4.822-18.376c.919-3.676-.689-7.811-3.444-9.648z"
      fill="#fff"
    />
    <path
      d="M237.838 314.477c19.848 11.578 20.124 30.049.275 41.627-19.848 11.578-52.102 11.578-71.951 0-20.124-11.303-20.124-30.049-.276-41.627 19.573-11.303 51.827-11.303 71.952 0z"
      fill="#00A355"
    />
    <path
      d="M236.724 318.807c.552-7.995-4.135-16.265-14.886-22.33-20.124-11.303-52.379-11.303-71.952 0-9.924 5.789-14.886 13.232-14.886 20.951v12.957c0 7.719 4.962 15.162 14.886 20.951 19.849 11.579 52.103 11.579 71.952 0 9.924-5.789 14.886-13.232 14.886-20.675v-12.957 1.103z"
      fill="#E4C865"
    />
    <path
      d="M221.838 297.856c-19.849-11.579-52.103-11.579-71.951 0-19.849 11.578-19.573 30.048.275 41.627 19.849 11.578 52.103 11.578 71.952 0 9.924-5.79 14.886-13.233 14.886-20.952v-.551-.276c-.827-7.167-5.789-14.335-15.162-19.848z"
      fill="#FF7B42"
    />
    <path
      d="M221.838 296.477c19.848 11.578 20.124 30.049.275 41.627-19.848 11.578-52.102 11.578-71.951 0-20.124-11.303-20.124-30.049-.276-41.627 19.573-11.303 51.827-11.303 71.952 0z"
      fill="url(#timely-payment__paint5_linear)"
    />
    <path
      d="M154.297 304.747c8.271-5.238 19.573-8.27 31.427-8.27s23.433 3.032 31.703 8.27c6.065 3.86 9.649 8.546 10.476 13.233 0-.552.275-1.103.275-1.654 0-4.962-3.859-10.476-10.751-14.611-8.27-5.238-19.849-8.27-31.703-8.27s-23.432 3.032-31.427 8.27c-6.616 4.135-10.475 9.649-10.475 14.611 0 .551 0 1.102.275 1.654.552-4.687 4.135-9.373 10.2-13.233z"
      fill="#F78800"
    />
    <path
      d="M408.838 286.477c19.848 11.578 20.124 30.049.275 41.627-19.848 11.578-52.102 11.578-71.951 0-20.124-11.303-20.124-30.049-.276-41.627 19.573-11.303 51.827-11.303 71.952 0z"
      fill="#00A355"
    />
    <path
      d="M409.724 286.807c.552-7.995-4.135-16.265-14.886-22.33-20.124-11.303-52.379-11.303-71.952 0-9.924 5.789-14.886 13.232-14.886 20.951v12.957c0 7.719 4.962 15.162 14.886 20.951 19.849 11.579 52.103 11.579 71.952 0 9.924-5.789 14.886-13.232 14.886-20.675v-12.957 1.103z"
      fill="#E4C865"
    />
    <path
      d="M394.838 265.856c-19.849-11.579-52.103-11.579-71.951 0-19.849 11.578-19.573 30.048.275 41.627 19.849 11.578 52.103 11.578 71.952 0 9.924-5.79 14.886-13.233 14.886-20.952v-.551-.276c-.827-7.167-5.789-14.335-15.162-19.848z"
      fill="#FF7B42"
    />
    <path
      d="M394.838 264.477c19.848 11.578 20.124 30.049.275 41.627-19.848 11.578-52.102 11.578-71.951 0-20.124-11.303-20.124-30.049-.276-41.627 19.573-11.303 51.827-11.303 71.952 0z"
      fill="url(#timely-payment__paint6_linear)"
    />
    <path
      d="M327.297 272.747c8.271-5.238 19.573-8.27 31.427-8.27s23.433 3.032 31.703 8.27c6.065 3.86 9.649 8.546 10.476 13.233 0-.552.275-1.103.275-1.654 0-4.962-3.859-10.476-10.751-14.611-8.27-5.238-19.849-8.27-31.703-8.27s-23.432 3.032-31.427 8.27c-6.616 4.135-10.475 9.649-10.475 14.611 0 .551 0 1.102.275 1.654.552-4.687 4.135-9.373 10.2-13.233z"
      fill="#F78800"
    />
    <path
      d="M409.724 267.807c.552-7.995-4.135-16.265-14.886-22.33-20.124-11.303-52.379-11.303-71.952 0-9.924 5.789-14.886 13.232-14.886 20.951v12.957c0 7.719 4.962 15.162 14.886 20.951 19.849 11.579 52.103 11.579 71.952 0 9.924-5.789 14.886-13.232 14.886-20.675v-12.957 1.103z"
      fill="#E4C865"
    />
    <path
      d="M394.838 246.856c-19.849-11.579-52.103-11.579-71.951 0-19.849 11.578-19.573 30.048.275 41.627 19.849 11.578 52.103 11.578 71.952 0 9.924-5.79 14.886-13.233 14.886-20.952v-.551-.276c-.827-7.167-5.789-14.335-15.162-19.848z"
      fill="#FF7B42"
    />
    <path
      d="M394.838 245.477c19.848 11.578 20.124 30.049.275 41.627-19.848 11.578-52.102 11.578-71.951 0-20.124-11.303-20.124-30.049-.276-41.627 19.573-11.303 51.827-11.303 71.952 0z"
      fill="url(#timely-payment__paint7_linear)"
    />
    <path
      d="M327.297 253.747c8.271-5.238 19.573-8.27 31.427-8.27s23.433 3.032 31.703 8.27c6.065 3.86 9.649 8.546 10.476 13.233 0-.552.275-1.103.275-1.654 0-4.962-3.859-10.476-10.751-14.611-8.27-5.238-19.849-8.27-31.703-8.27s-23.432 3.032-31.427 8.27c-6.616 4.135-10.475 9.649-10.475 14.611 0 .551 0 1.102.275 1.654.552-4.687 4.135-9.373 10.2-13.233z"
      fill="#F78800"
    />
    <path
      d="M409.724 248.807c.552-7.995-4.135-16.265-14.886-22.33-20.124-11.303-52.379-11.303-71.952 0-9.924 5.789-14.886 13.232-14.886 20.951v12.957c0 7.719 4.962 15.162 14.886 20.951 19.849 11.579 52.103 11.579 71.952 0 9.924-5.789 14.886-13.232 14.886-20.675v-12.957 1.103z"
      fill="#E4C865"
    />
    <path
      d="M394.838 227.856c-19.849-11.579-52.103-11.579-71.951 0-19.849 11.578-19.573 30.048.275 41.627 19.849 11.578 52.103 11.578 71.952 0 9.924-5.79 14.886-13.233 14.886-20.952v-.551-.276c-.827-7.167-5.789-14.335-15.162-19.848z"
      fill="#FF7B42"
    />
    <path
      d="M394.838 226.477c19.848 11.578 20.124 30.049.275 41.627-19.848 11.578-52.102 11.578-71.951 0-20.124-11.303-20.124-30.049-.276-41.627 19.573-11.303 51.827-11.303 71.952 0z"
      fill="url(#timely-payment__paint8_linear)"
    />
    <path
      d="M327.297 234.747c8.271-5.238 19.573-8.27 31.427-8.27s23.433 3.032 31.703 8.27c6.065 3.86 9.649 8.546 10.476 13.233 0-.552.275-1.103.275-1.654 0-4.962-3.859-10.476-10.751-14.611-8.27-5.238-19.849-8.27-31.703-8.27s-23.432 3.032-31.427 8.27c-6.616 4.135-10.475 9.649-10.475 14.611 0 .551 0 1.102.275 1.654.552-4.687 4.135-9.373 10.2-13.233z"
      fill="#F78800"
    />
    <path
      d="M415.724 229.807c.552-7.995-4.135-16.265-14.886-22.33-20.124-11.303-52.379-11.303-71.952 0-9.924 5.789-14.886 13.232-14.886 20.951v12.957c0 7.719 4.962 15.162 14.886 20.951 19.849 11.579 52.103 11.579 71.952 0 9.924-5.789 14.886-13.232 14.886-20.675v-12.957 1.103z"
      fill="#E4C865"
    />
    <path
      d="M400.838 208.856c-19.849-11.579-52.103-11.579-71.951 0-19.849 11.578-19.573 30.048.275 41.627 19.849 11.578 52.103 11.578 71.952 0 9.924-5.79 14.886-13.233 14.886-20.952v-.551-.276c-.827-7.167-5.789-14.335-15.162-19.848z"
      fill="#FF7B42"
    />
    <path
      d="M400.838 207.477c19.848 11.578 20.124 30.049.275 41.627-19.848 11.578-52.102 11.578-71.951 0-20.124-11.303-20.124-30.049-.276-41.627 19.573-11.303 51.827-11.303 71.952 0z"
      fill="url(#timely-payment__paint9_linear)"
    />
    <path
      d="M333.297 215.747c8.271-5.238 19.573-8.27 31.427-8.27s23.433 3.032 31.703 8.27c6.065 3.86 9.649 8.546 10.476 13.233 0-.552.275-1.103.275-1.654 0-4.962-3.859-10.476-10.751-14.611-8.27-5.238-19.849-8.27-31.703-8.27s-23.432 3.032-31.427 8.27c-6.616 4.135-10.475 9.649-10.475 14.611 0 .551 0 1.102.275 1.654.552-4.687 4.135-9.373 10.2-13.233z"
      fill="#F78800"
    />
    <path
      d="M401.724 210.807c.552-7.995-4.135-16.265-14.886-22.33-20.124-11.303-52.379-11.303-71.952 0-9.924 5.789-14.886 13.232-14.886 20.951v12.957c0 7.719 4.962 15.162 14.886 20.951 19.849 11.579 52.103 11.579 71.952 0 9.924-5.789 14.886-13.232 14.886-20.675v-12.957 1.103z"
      fill="#E4C865"
    />
    <path
      d="M386.838 189.856c-19.849-11.579-52.103-11.579-71.951 0-19.849 11.578-19.573 30.048.275 41.627 19.849 11.578 52.103 11.578 71.952 0 9.924-5.79 14.886-13.233 14.886-20.952v-.551-.276c-.827-7.167-5.789-14.335-15.162-19.848z"
      fill="#FF7B42"
    />
    <path
      d="M386.838 188.477c19.848 11.578 20.124 30.049.275 41.627-19.848 11.578-52.102 11.578-71.951 0-20.124-11.303-20.124-30.049-.276-41.627 19.573-11.303 51.827-11.303 71.952 0z"
      fill="url(#timely-payment__paint10_linear)"
    />
    <path
      d="M319.297 196.747c8.271-5.238 19.573-8.27 31.427-8.27s23.433 3.032 31.703 8.27c6.065 3.86 9.649 8.546 10.476 13.233 0-.552.275-1.103.275-1.654 0-4.962-3.859-10.476-10.751-14.611-8.27-5.238-19.849-8.27-31.703-8.27s-23.432 3.032-31.427 8.27c-6.616 4.135-10.475 9.649-10.475 14.611 0 .551 0 1.102.275 1.654.552-4.687 4.135-9.373 10.2-13.233z"
      fill="#F78800"
    />
    <defs>
      <linearGradient
        id="timely-payment__paint0_linear"
        x1={37.833}
        y1={61.792}
        x2={87.46}
        y2={100.524}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCFA8" />
        <stop offset={1} stopColor="#C27F5D" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint1_linear"
        x1={47.672}
        y1={60.569}
        x2={146.627}
        y2={120.909}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCFA8" />
        <stop offset={1} stopColor="#C27F5D" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint2_linear"
        x1={41.298}
        y1={135.325}
        x2={60.791}
        y2={215.873}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCFA8" />
        <stop offset={1} stopColor="#C27F5D" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint3_linear"
        x1={321.291}
        y1={269.427}
        x2={274.783}
        y2={212.726}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.68} />
        <stop offset={1} stopColor="#00BA61" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint4_linear"
        x1={193.454}
        y1={155.485}
        x2={174.422}
        y2={267.515}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#F4F2FF" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint5_linear"
        x1={135.002}
        y1={317.393}
        x2={236.73}
        y2={317.393}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF691" />
        <stop offset={1} stopColor="#FFCC5E" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint6_linear"
        x1={308.002}
        y1={285.393}
        x2={409.73}
        y2={285.393}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF691" />
        <stop offset={1} stopColor="#FFCC5E" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint7_linear"
        x1={308.002}
        y1={266.393}
        x2={409.73}
        y2={266.393}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF691" />
        <stop offset={1} stopColor="#FFCC5E" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint8_linear"
        x1={308.002}
        y1={247.393}
        x2={409.73}
        y2={247.393}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF691" />
        <stop offset={1} stopColor="#FFCC5E" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint9_linear"
        x1={314.002}
        y1={228.393}
        x2={415.73}
        y2={228.393}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF691" />
        <stop offset={1} stopColor="#FFCC5E" />
      </linearGradient>
      <linearGradient
        id="timely-payment__paint10_linear"
        x1={300.002}
        y1={209.393}
        x2={401.73}
        y2={209.393}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF691" />
        <stop offset={1} stopColor="#FFCC5E" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgComponent
